export function removeEmojis(str: string) {
  return str.replace(/([\u2700-\u27BF\uE000-\uF8FF\uD83C-\uDBFF\uDC00-\uDFFF])+|[\u200D\uFE0F]/g, '').replace('  ', '')
}
